import { BedroomsContainer } from '../../containers/advancedFilters/BedroomsContainer';
import { IFilter } from '../../types/filters';

export const bedrooms: IFilter = {
  component: BedroomsContainer,
};
